var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "58.99px",
    height: "59.144px",
    viewBox: "0,0,255.33334,256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4.32842,4.32842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5293,0.03516c-12.407,0 -22.5,10.093 -22.5,22.5c0,12.407 10.093,22.5 22.5,22.5c5.845,0 11.17273,-2.24025 15.17773,-5.90625l2.91602,2.91602c-1.216,1.806 -1.03155,4.28291 0.56445,5.87891l9.90039,9.89844c0.906,0.906 2.0942,1.35742 3.2832,1.35742c1.19,0 2.38111,-0.45338 3.28711,-1.35938c0.877,-0.877 1.36133,-2.04416 1.36133,-3.28516c0.001,-1.241 -0.48333,-2.4062 -1.36133,-3.2832l-9.89844,-9.90039c-1.54,-1.54 -3.89564,-1.75669 -5.68164,-0.67969l-2.95703,-2.95703c3.667,-4.004 5.9082,-9.33469 5.9082,-15.17969c0,-12.407 -10.093,-22.5 -22.5,-22.5zM22.5293,5.03516c9.649,0 17.5,7.851 17.5,17.5c0,9.649 -7.851,17.5 -17.5,17.5c-9.649,0 -17.5,-7.851 -17.5,-17.5c0,-9.649 7.851,-17.5 17.5,-17.5zM22.5293,7.03516c-8.55973,0.00097 -15.49824,6.94027 -15.49824,15.5c0,8.55973 6.93851,15.49903 15.49824,15.5c8.55973,-0.00097 15.49824,-6.94027 15.49824,-15.5c0,-8.55973 -6.93851,-15.49903 -15.49824,-15.5z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.49bacb095624436cefc2d9ddfb4faf93.svg";
export { ForwardRef as ReactComponent };